import React, { useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { getBlogPosts } from "../../lib/blogPosts";
import { getBlogCategories } from "../../lib/blogCategory";
import PostFilterTab from "./PostFilterTab";
import { mapCategoriesToPosts } from "../../components/mapCategoriesToPosts";
import Seo from "../../components/common/Seo";
import Header from "../../components/home-7/Header";
import FooterDefault from "../../components/footer/common-footer";
import {useParams} from "react-router-dom";
import MobileMenu from "../../components/header/MobileMenu";
import BlogBanner from "./BlogBanner";
import LoaderAnimation from "../../lib/loaderAnimation";

export default function Blogs() {
    const { targetCategory} = useParams();

    const {
        data: posts = [],
        isLoading,
        isError
    } = useQuery({
        queryKey: ['posts'],
        queryFn: getBlogPosts,
    });

    const {
        data: categories = [],
        isLoading: isCategoriesLoading,
        isError: isCategoriesError
    } = useQuery({
        queryKey: ['categories'],
        queryFn: getBlogCategories,
    });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;

    const mappedPosts = mapCategoriesToPosts(posts, categories);
    const filteredCategories = categories.filter((category) =>
        posts.some((post) => post.categories.includes(category.id))
    );

    const targetCategoryId = targetCategory
        ? categories.find((category) => category.slug === targetCategory)?.id
        : null;

    const changePage = (page, totalPages) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    if (isError || isCategoriesError) {
        return <div>Erreur lors du chargement des données.</div>;
    }

    return (
        <>
            <Seo pageTitle="blog"
                 pageDescription="Blog Groupe Talent Handicap Formation - Accueil"
                 pageUrl={window.location.href} />
            <span className="header-span"></span>
            <Header />
            <MobileMenu />

            <BlogBanner/>

            <section className="blog-section">
                <div className="auto-container">
                    { isLoading || isCategoriesLoading ? (
                        <LoaderAnimation />
                    ) : (
                        <div className="row fadeInUp animated">
                            <PostFilterTab
                                products={mappedPosts}
                                categories={filteredCategories}
                                targetCategoryId={targetCategoryId}
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                onPageChange={changePage}
                            />
                        </div>
                    )}
                </div>
            </section>

            <FooterDefault footerStyle="style-six alternate -type-11"/>
        </>
    );
}